import { inject, Injectable } from '@angular/core';
import { Indexer } from '../indexers/indexer';
import { SettingHelper } from './setting.helper';

@Injectable({
  providedIn: 'root'
})
export class ChainHelper {

  /**
   * Indexer provider
   */
  indexer_provider = inject(Indexer);

  /**
   * Setting helper
   */
  setting_helper = inject(SettingHelper);

  /**
   * Read object
   * 
   * @param id
   */
  async readObject(id: string): Promise<any> {
    let indexer = this.setting_helper.store().settings.indexer;
    return await this.indexer_provider.readObject(indexer, id);
  }

  /**
   * Read dynamic field
   * 
   * @param id
   * @param signature
   */
  async readDynamicField(id: string, type: string, signature: string): Promise<any> {
    let indexer = this.setting_helper.store().settings.indexer;
    return await this.indexer_provider.readDynamicField(indexer, id, type, signature);
  }

  /**
   * Read balance
   * 
   * @param id
   * @param signature
   */
  async readBalance(id: string, signature: string): Promise<bigint> {
    let indexer = this.setting_helper.store().settings.indexer;
    return await this.indexer_provider.readBalance(indexer, id, signature);
  }

  /**
   * Read events
   * 
   * @param version
   * @param event_type 
   * @param sender
   */
  async readEvents(version: number, event_type: string, sender?: string): Promise<Array<any>> {
    let indexer = this.setting_helper.store().settings.indexer;
    return await this.indexer_provider.readEvents(indexer, version, event_type, sender);
  }
}
